var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoominfoByDomains(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ea576c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45287,
    stopColor: "#ea1f1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#ea1b15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#811b46"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.01855,69.04071c0,.38464.30994.69464.6944.69464h13.41205c.38446,0,.6944-.31006.6944-.69464v-3.54443c0-.38458-.30994-.69458-.6944-.69458h-6.99512l27.42413-26.09424v3.19836c0,.38452.30994.69452.6944.69452h3.55731c.38434-.01227.68195-.32233.68195-.70697v-10.93237c0-.3847-.31-.6947-.69446-.6947h-4.2392l-6.70599.01239c-.38446,0-.6944.30994-.6944.69452v3.53198c0,.3847.30994.6947.6944.6947h3.25629l-31.08575,29.60181v4.23901Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.2702,42.59863c.38434,0,.68195-.31.68195-.69452v-6.70587l4.93365.00171,11.63977-.01404c.38428,0,.6944-.30994.6944-.69464v-3.53198c0-.38458-.31012-.6947-.68207-.6947h-20.80017c-.38446,0-.6944.31-.6944.6947v10.94482c0,.38464.30994.69452.6944.69452h3.53247Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "73.98151 57.04248 67.05499 52.48737 61.68097 56.00177 56.32404 52.48737 52.41724 55.04639 52.41724 53.56213 49.39758 53.56213 49.39758 69.71826 52.51959 69.71826 52.51959 58.64612 56.32404 56.15533 60.12848 58.64612 60.12848 69.71826 63.25055 69.71826 63.25055 58.64612 67.05499 56.15533 70.85944 58.66321 70.85944 69.73535 73.98151 69.73535 73.98151 57.04248"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoominfoByDomains);
export default __webpack_public_path__ + "static/media/zoominfo-by-domains.037ef2feaad5dbf527fd1f45f6556f41.svg";
export { ForwardRef as ReactComponent };